module.exports = __webpack_public_path__ + "static/media/Theros-horizontal.6ded3461.png";